import React, { useState, useEffect } from 'react';
import './ApexNavbar.css';
import logo from './assets/eagle_apex_logo.png';
import { FaLock, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ApexNavbar = () => {
  const { t } = useTranslation();
  const [shrink, setShrink] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [gamesOpen, setGamesOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShrink(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setMenuActive(!menuActive);

  return (
    <nav className={`apex-navbar ${shrink ? 'shrink' : ''}`}>
      <div className="apex-navbar-header">
        <div className="apex-navbar-left">
          <a href="/" className="apex-navbar-logo-link">
            <img src={logo} alt="EAGLE SCRIPT - Apex Legends No Recoil Script Logo" className="apex-navbar-logo" />
          </a>
        </div>

        <div className="apex-navbar-hamburger" onClick={toggleMenu}>
          <span></span><span></span><span></span>
        </div>
      </div>

      <div className={`apex-navbar-content ${menuActive ? 'active' : ''}`}>
        <ul className="apex-navbar-menu">
          <li>
            <a href="/" onClick={() => setMenuActive(false)}>
              {t('home')}
            </a>
          </li>
          <li>
            <a href="#apex-features" onClick={() => setMenuActive(false)}>
              {t('features')}
            </a>
          </li>
          <li>
            <a href="#pricing" onClick={() => setMenuActive(false)}>
              {t('pricing')}
            </a>
          </li>
          <li className="apex-games-dropdown-container">
            <button 
              className="apex-games-dropdown-button" 
              onClick={() => setGamesOpen(!gamesOpen)}
            >
              Other Games {gamesOpen ? <FaChevronUp /> : <FaChevronDown />}
            </button>
            {gamesOpen && (
              <ul className="apex-games-dropdown">
                <li>
                  <a 
                    href="/" 
                    onClick={() => {
                      setGamesOpen(false);
                      setMenuActive(false);
                    }}
                  >
                    Rust
                  </a>
                </li>
              </ul>
            )}
          </li>
        </ul>
        <div className="apex-navbar-right">
          <a href="/private-login" className="apex-private-login-link" onClick={() => setMenuActive(false)}>
            <FaLock className="apex-lock-icon" />
            <span className="apex-login-text">{t('private_login')}</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default ApexNavbar;
